export default __webpack_public_path__ + "static/media/img_shop-type06.71bbafe3.png";